import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./style.scss";
import { Banner } from "@app/types";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "@app/constants";

type SliderSpaceBetweenProps = {
  banners: Banner[];
};

function SliderSpaceBetween({ banners }: SliderSpaceBetweenProps) {
  const navigate = useNavigate();

  const handleBannerClick = (banner: Banner) => {
    if (banner.bookId) {
      return navigate(`/${RoutePath.BOOK_DETAIL}/${banner.bookId}`);
    }

    if (banner.link) {
      return window.open(banner.link);
    }

    if (banner.categoryId) {
      return navigate(
        `${RoutePath.BOOK_BY_CATEGORY}?category_id=${banner.categoryId}`
      );
    }
  };

  return (
    <Swiper
      spaceBetween={5}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, Pagination]}
      className="slider-space-between"
      loop
      autoplay={{ disableOnInteraction: false }}
    >
      {!!banners.length &&
        banners.map((item) => (
          <SwiperSlide key={item.id} onClick={() => handleBannerClick(item)}>
            <img src={item.thumbnail} alt="" />
          </SwiperSlide>
        ))}
    </Swiper>
  );
}

export default SliderSpaceBetween;
